import React, {useState} from "react";
import HeaderComponent from "../../components/HeaderComponent";
import "./../../utils/Style/pages/EODclosing.scss";
import TrxTable from "../../components/EODClosing/TrxTable";
import EodDetails from "../../components/EODClosing/EodDetails";

function EODclosing() {
    const [activeRowIndex, setActiveRowIndex] = useState(null);
    const [visible, setVisible] = useState(false);

    return (
        <>
            <HeaderComponent title="End Of Day Closing"/>
            <div className="EODclosingPage">
                <div className="container-fluid EODclosingPagecontainer">
                    <div className="row">
                        <div className="col-lg-10 col-md-12 currentSales">

                            {!visible &&
                                <TrxTable
                                    activeRowIndex={activeRowIndex}
                                    setActiveRowIndex={setActiveRowIndex}
                                    setVisible={setVisible}
                                />
                            }

                            <EodDetails
                                visible={visible}
                                setVisible={setVisible}
                                activeRowIndex={activeRowIndex}
                                setActiveRowIdex={setActiveRowIndex}
                            />

                        </div>
                        <div className="col-lg-2 col-md-12"></div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EODclosing;